import Duck from 'custom-redux-ducks-ts'

export const contact = new Duck('contact', 'eduprivada')
